export const carProfileObserveSections = [
    'videoSection',
    'similarCarsSection',
    'featuredGrid',
    'valueProp',
    'imperfectionSection',
    'carOverviewSection',
    'purchaseStepsSection',
];

export const carProfileSerctions = [
    'main',
    'gallery',
    'info',
    'similarCarsStatic',
    'carDetailsTable',
];
